import { render, staticRenderFns } from "./AddConfirmFeedback.vue?vue&type=template&id=947f8cb4&scoped=true"
import script from "./AddConfirmFeedback.vue?vue&type=script&lang=js"
export * from "./AddConfirmFeedback.vue?vue&type=script&lang=js"
import style0 from "./AddConfirmFeedback.vue?vue&type=style&index=0&id=947f8cb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947f8cb4",
  null
  
)

export default component.exports